import React from "react";
import PageShell from "@/components/PageShell";
import { Link } from "react-router-dom";

const STATS = [
    ["2018", "Founded"],
    ["6", "Drops / Year"],
    ["1000", "Pieces / Run"],
    ["32", "Cities Stocked"],
];

const About = () => {
    return (
        <PageShell
            kicker="[Manifesto / Vol. 06]"
            title="We Knit"
            accent="The Streets."
            intro="UKnitwear is an independent label working out of a converted print shop in the East district. We design heavyweight knitwear and street uniform for people who treat clothing like architecture — built, layered, lived in."
            testid="about-page"
        >
            <section className="grid grid-cols-2 md:grid-cols-4 border-b-4 border-ink divide-x-2 divide-ink">
                {STATS.map(([n, l]) => (
                    <div key={l} className="p-6 md:p-10 text-center bg-bone">
                        <div className="font-heading text-4xl md:text-6xl leading-none">
                            {n}
                        </div>
                        <div className="mt-2 font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                            {l}
                        </div>
                    </div>
                ))}
            </section>

            <section className="grid grid-cols-1 md:grid-cols-2 border-b-4 border-ink">
                <div className="p-6 md:p-12 lg:p-16 md:border-r-2 border-ink">
                    <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-muted-foreground">
                        // 01 / The Process
                    </span>
                    <h2 className="font-heading text-4xl md:text-5xl uppercase leading-none mt-3">
                        Heavyweight, Slow-Run.
                    </h2>
                    <p className="mt-6 leading-relaxed text-sm md:text-base">
                        Every garment is patterned in-house and produced in runs of no more
                        than 1,000 units. We work with three family-owned mills in northern
                        Portugal and Japan — picked for their tolerance for our 500gsm
                        loopbacks, raw selvedge weaves, and bonded seams.
                    </p>
                    <p className="mt-4 leading-relaxed text-sm md:text-base">
                        No archives. No restocks. When a run sells out, it stays sold out.
                    </p>
                </div>
                <div className="p-6 md:p-12 lg:p-16 bg-ink text-black">
                    <span className="font-mono-ui text-xs uppercase tracking-[0.25em] text-black/40">
                        // 02 / The Cast
                    </span>
                    <h2 className="font-heading text-4xl md:text-5xl uppercase leading-none mt-3">
                        Builders, Riders, Runners.
                    </h2>
                    <p className="mt-6 leading-relaxed text-sm md:text-base text-black/80">
                        We cast from the streets we shoot in. Workers off their shift, BMX
                        riders, sound engineers, students at the technical school. The
                        clothing is built to outlast every one of them.
                    </p>
                </div>
            </section>

            <section className="px-4 md:px-8 py-20 text-center">
                <h2 className="font-heading text-4xl md:text-7xl uppercase leading-[0.9] max-w-4xl mx-auto">
                    We do not chase <span className="text-hazard">trends.</span>
                    <br />
                    We build weapons for the wardrobe.
                </h2>
                <Link
                    to="/shop"
                    data-testid="about-shop-link"
                    className="inline-block mt-10 bg-ink text-black border-2 border-ink px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.25em] hover:bg-hazard hover:border-hazard"
                >
                    Shop The Manifesto →
                </Link>
            </section>
        </PageShell>
    );
};

export default About;
